import router from "../../router/router";
const app = {
  namespaced: true,
  state: {
    routesTree: [], // 路由数据原始的关系树
    menuList: [],
    pageOpenedList: [
      {
        title: "首页",
        name: "index",
        selected: true,
        path: "/index",
      },
    ],
  },
  mutations: {},
};
export default app;
